module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "wrapper-padding-bottom"
  }, [(!_vm.isTouch) ? _c('div', {
    staticClass: "span-full bgblue",
    attrs: {
      "data-type": "layout"
    }
  }, [_c('div', {
    staticClass: "full-inner",
    attrs: {
      "id": "sea"
    }
  }, _vm._l((_vm.fishSchoolData), function(fish, index) {
    return _c('div', {
      staticClass: "fish",
      class: fish.color,
      style: ({
        left: fish.x,
        top: fish.y
      })
    })
  })), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.isTouch) ? _c('div', {
    staticClass: "span-full bgblue"
  }, [_c('div', {
    staticClass: "full-inner",
    attrs: {
      "id": "sea-responsive"
    }
  }, [_c('img', {
    attrs: {
      "src": '/static/images/solutions-responsive-hero.png',
      "alt": ""
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "error-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showArrow),
      expression: "showArrow"
    }],
    staticClass: "read-more"
  }, [_c('icon', {
    attrs: {
      "name": "customangledown",
      "scale": "2.5"
    }
  })], 1)]), _vm._v(" "), _vm._m(1)], 1) : _vm._e(), _vm._v(" "), _c('solutions-promises'), _vm._v(" "), _c('solutions-tips')], 1), _vm._v(" "), _c('footer-app')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more",
    attrs: {
      "href": "#",
      "data-index": "0"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more",
    attrs: {
      "href": "#",
      "data-index": "0"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18ef27fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Solutions.vue
// module id = 157
// module chunks = 1